const _ = require('lodash');

const config = {
  has: (path) => typeof _.get(window.breatheLifeConfig, path) !== 'undefined',
  get: (path) => _.get(window.breatheLifeConfig, path),
  isLoaded: window.breatheLifeConfig !== undefined,
};

module.exports = { config };
